export enum LinkedPayoutReason {
    Split = 'Split',
}
